var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPupload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7 14.77H8V10.075L10.1 12.175L10.808 11.462L7.5 8.154L4.192 11.462L4.906 12.169L7 10.075V14.769V14.77ZM2.115 18C1.655 18 1.271 17.846 0.963 17.538C0.654333 17.2293 0.5 16.845 0.5 16.385V1.615C0.5 1.155 0.654333 0.771 0.963 0.463C1.271 0.154333 1.655 0 2.115 0H10L14.5 4.5V16.385C14.5 16.845 14.346 17.229 14.038 17.537C13.7293 17.8457 13.345 18 12.885 18H2.115ZM9.5 5V1H2.115C1.96167 1 1.82067 1.064 1.692 1.192C1.564 1.32067 1.5 1.46167 1.5 1.615V16.385C1.5 16.5383 1.564 16.6793 1.692 16.808C1.82067 16.936 1.96167 17 2.115 17H12.885C13.0383 17 13.1793 16.936 13.308 16.808C13.436 16.6793 13.5 16.5383 13.5 16.385V5H9.5Z",
    fill: "#FEFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPupload);
export default __webpack_public_path__ + "static/media/pupload.583e230674fe9927298832edd84f5259.svg";
export { ForwardRef as ReactComponent };